import { getActiveOrganization } from "selectors/organizations";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import Countries from "const/Countries";
import DateFormats from "const/DateFormats";
import DateTimeFormats from "const/DateTimeFormats";
import moment from "moment";

const useDateFormatter = () => {
  const { countryCode } = useSelector(getActiveOrganization);

  const dateFormat = countryCode === Countries.US ? DateFormats.US : DateFormats.EU;

  return useCallback((date, utc = true, withTime) => {
    const momentDate = utc ? moment.utc(date) : moment(date);

    return [
      momentDate.format(dateFormat),
      withTime && momentDate.format(DateTimeFormats.TIME)
    ].filter(Boolean).join(" ");
  }, [dateFormat]);
};

export default useDateFormatter;
